import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ palette, colors }: Theme) => createStyles({
  root: {},
  input: {},
  labelRoot: {
    '&$focused': {
      color: palette.text.secondary,
    },
  },
  inputUnderline: {
    '&:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&&:hover:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$focused:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$disabled:before': {
      borderBottomStyle: 'dashed',
    },
  },
  focused: {},
  hovered: {},
  disabled: {
    color: palette.disabledInput.color,
  },
  helpIcon: {
    fontSize: '0.60rem',
    marginRight: 4,
  },
  iconTooltip: {
    fontSize: 14,
    color: colors.icon,
    verticalAlign: 'middle',
    marginBottom: 4,
    marginLeft: 8,
  },
  commentButtonWrapper: {
    textAlign: 'center',
  },
  comment: {
    fontSize: '12px',
    padding: '0 10px 0 10px',
  },
}), { name: 'FormInput' });

export default useStyles;
